import t from "@ext/localization/locale/translate";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

interface FragmentActionsProps {
	onClickEdit: () => void;
}

const FragmentActions = ({ onClickEdit }: FragmentActionsProps) => {
	const tooltip = t("edit2");

	return (
		<GlassToolbarButton aria-label={tooltip} onClick={onClickEdit} tooltipText={tooltip}>
			<GlassToolbarIcon icon="pencil" />
		</GlassToolbarButton>
	);
};

export default FragmentActions;
